import type { CheckoutSkiAncillaryService } from '@/scopes/checkout/domain/types'
import { produce } from 'immer'

interface SkiAncillaryServiceUpdateEditingPayload {
  participantId: string
  value: string | null
}

export function updateEditingSkiAncillaryServiceValue(payload: SkiAncillaryServiceUpdateEditingPayload) {
  return produce((service: CheckoutSkiAncillaryService) => {
    if (!payload.value)
      return
    service.editingSelectedValues[payload.participantId].id = payload.value
  })
}

export function updateEditingSkiAncillaryServiceSportType(payload: SkiAncillaryServiceUpdateEditingPayload) {
  return produce((service: CheckoutSkiAncillaryService) => {
    if (!payload.value)
      return
    service.editingSelectedValues[payload.participantId].sportType = payload.value
    service.editingSelectedValues[payload.participantId].level = service.levels[payload.value]?.levels.find(level => level.appliesToParticipants?.includes(payload.participantId))?.type || service.levels[payload.value]?.levels[0]?.type
    service.editingSelectedValues[payload.participantId].id = service.durations[service.editingSelectedValues[payload.participantId].duration]?.availableOptions.find(optionId =>
      service.participants[payload.participantId].availableOptions.includes(optionId)
      && service.options[optionId].startDate === service.editingSelectedValues[payload.participantId].startDate
      && service.options[optionId].level === service.editingSelectedValues[payload.participantId].level
      && service.options[optionId].sportType === payload.value,
    ) || service.isNoneOption || ''
  })
}

export function updateEditingSkiAncillaryServiceDuration(payload: SkiAncillaryServiceUpdateEditingPayload) {
  return produce((service: CheckoutSkiAncillaryService) => {
    if (!payload.value)
      return
    service.editingSelectedValues[payload.participantId].duration = payload.value
    service.editingSelectedValues[payload.participantId].value = service.options[service.durations[payload.value].availableOptions[0]].value
    service.editingSelectedValues[payload.participantId].startDate = service.options[service.durations[payload.value].availableOptions[0]].startDate
    service.editingSelectedValues[payload.participantId].id = service.durations[payload.value].availableOptions.find(optionId =>
      service.participants[payload.participantId].availableOptions.includes(optionId)
      && service.options[optionId].startDate === service.editingSelectedValues[payload.participantId].startDate
      && service.options[optionId].level === service.editingSelectedValues[payload.participantId].level
      && service.options[optionId].sportType === service.editingSelectedValues[payload.participantId].sportType,
    ) || ''
  })
}

export function updateEditingSkiAncillaryServiceStartDate(payload: SkiAncillaryServiceUpdateEditingPayload) {
  return produce((service: CheckoutSkiAncillaryService) => {
    if (!payload.value)
      return
    service.editingSelectedValues[payload.participantId].startDate = payload.value
    service.editingSelectedValues[payload.participantId].id = service.durations[service.editingSelectedValues[payload.participantId].duration]?.availableOptions.find(optionId =>
      service.participants[payload.participantId].availableOptions.includes(optionId)
      && service.options[optionId].startDate === payload.value
      && service.options[optionId].level === service.editingSelectedValues[payload.participantId].level
      && service.options[optionId].sportType === service.editingSelectedValues[payload.participantId].sportType,
    ) || ''
  })
}

export function updateEditingSkiAncillaryServiceLevel(payload: SkiAncillaryServiceUpdateEditingPayload) {
  return produce((service: CheckoutSkiAncillaryService) => {
    if (!payload.value)
      return
    service.editingSelectedValues[payload.participantId].level = payload.value

    service.editingSelectedValues[payload.participantId].id = service.durations[service.editingSelectedValues[payload.participantId].duration]?.availableOptions.find(optionId =>
      service.participants[payload.participantId].availableOptions.includes(optionId)
      && service.options[optionId].startDate === service.editingSelectedValues[payload.participantId].startDate
      && service.options[optionId].level === payload.value
      && service.options[optionId].sportType === service.editingSelectedValues[payload.participantId].sportType,
    ) || ''
  })
}

export function saveEditingSkiAncillaryServiceValue(payload: SkiAncillaryServiceUpdateEditingPayload) {
  return produce((service: CheckoutSkiAncillaryService) => {
    service.participants[payload.participantId].selectedValue = payload.value
  })
}
